import {
  fetchStationCollection,
  fetchStation,
  fetchPlayouts,
  fetchUnderlineTrack,
  fetchStationPage,
  fetchRandomStation,
} from './station.service';
import { fetchShowCollection, fetchShow, fetchSchedules } from './show.service';
import { fetchCampaign } from './campaign.service';
import { fetchPodcastCollection, fetchPodcast, fetchPodcastBasic, fetchRelatedPodcast } from './podcast.service';
import { fetchTagCollection, fetchTagPage, fetchTag } from './tag.service';
import { fetchOverview, fetchMixed } from './overview.service';
import { fetchOverviewWithReferences } from './overviewWithReferences.service';
import {
  fetchUser,
  fetchFavoritePodcasts,
  fetchFavoriteStations,
  fetchFavorites,
  fetchProgress,
  mutateFavorite,
  mutateProgress,
} from './user.service';
import { fetchSearch } from './search.service';
import { subscribeToScheduleEvents, subscribeToStationEvents } from './subscription.service';
import { fetchPromotionCollection } from './promotion.service';
import { fetchCollectionConfig } from './collectionConfig.service';
import optimizely, { optimizelyFeatures } from '../optimizely';
import logger from 'util/logger';

const getFetchFunction = (contentTypeId) => {
  const overviewWithReference = optimizely.getFeatureVariable(
    optimizelyFeatures.OVERVIEW_WITH_REFERENCES_TEST,
    'variant'
  );

  // !TODO: remove console warn, this is only used for qa'er
  overviewWithReference
    ? logger.warn('Variant with new query is active')
    : logger.warn('Variant with old query is active');

  switch (contentTypeId) {
    case 'podcastCollection':
      return fetchPodcastCollection;
    case 'featuredPodcast':
      return fetchPodcastBasic;
    case 'podcast':
      return fetchPodcast;
    case 'onDemandCollection':
    case 'showCollection':
      return fetchShowCollection;
    case 'show':
      return fetchShow;
    case 'playouts':
      return fetchPlayouts;
    case 'stationCollection':
      return fetchStationCollection;
    case 'station':
      return fetchStation;
    case 'schedules':
      return fetchSchedules;
    case 'stationPage':
      return fetchStationPage;
    case 'genre':
    case 'mood':
      return fetchTag;
    case 'genrePage':
      return fetchTagPage;
    case 'tagCollection':
      return fetchTagCollection;
    case 'overview':
    case 'overviewCollection':
      return overviewWithReference ? fetchOverviewWithReferences : fetchOverview;
    case 'mixedCollection':
      return fetchMixed;
    case 'promotionCollection':
      return fetchPromotionCollection;
    case 'campaign':
      return fetchCampaign;
    default:
      logger.error(`no fetch function for contentTypeId ${contentTypeId}`);
      return null;
  }
};

const graphql = {
  fetchShowCollection,
  fetchShow,
  fetchStationCollection,
  fetchStation,
  fetchPlayouts,
  fetchUnderlineTrack,
  fetchStationPage,
  fetchPromotionCollection,
  fetchRandomStation,
  fetchUser,
  fetchPodcastCollection,
  fetchPodcast,
  fetchPodcastBasic,
  fetchProgress,
  fetchRelatedPodcast,
  fetchTagCollection,
  fetchTagPage,
  fetchTag,
  fetchOverview,
  fetchFavorites,
  fetchFavoritePodcasts,
  fetchFavoriteStations,
  getFetchFunction,
  fetchSearch,
  fetchMixed,
  mutateFavorite,
  mutateProgress,
  subscribeToScheduleEvents,
  subscribeToStationEvents,
  fetchCampaign,
  fetchCollectionConfig,
};

export default graphql;
